<template>
  <div class="hubspot">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>HubSpot CRM <small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
          <div class="icon">
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon add-margin-right="20px" />
              <div v-if="activeIntegration">
                <font
                  title="Configurações"
                  size="6"
                  color="black"
                  @click.prevent="toogleUpdateIntegration()">
                  <i class="ik ik-settings" />
                </font>
              </div>
              <div v-else>
                <font
                  title="Configurações"
                  size="6"
                  color="gray">
                  <i class="ik ik-settings" />
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="hubspot"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com o HubSpot CRM?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header d-flex justify-content-between align-items-center">
            <h4 class="modal-title">Configurar HubSpot CRM</h4>
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon />
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <ErrorAlert :error="errorAlert" />
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Usuário HubSpot</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="ownerId"
                  v-model="ownerId">
                  <option
                    v-for="option in ownersOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Chamada Atendida</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="dispositionIdAnswered"
                  v-model="dispositionIdAnswered">
                  <option
                    v-for="option in dispositionsOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Chamada Não Atendida</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="dispositionIdNotAnswered"
                  v-model="dispositionIdNotAnswered">
                  <option
                    v-for="option in dispositionsOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">Salvar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração HubSpot atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração HubSpot removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialHubSpot"
      title="Tutorial HubSpot"
      video-url="https://www.youtube.com/embed/miyBbV5hgEQ" />
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import ArtificialIntelligenceIcon from '@/components/Common/ArtificialIntelligenceIcon.vue'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationHubspot',
  components: {
    ArtificialIntelligenceIcon,
    TutorialVideoModal
  },
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      ownerId: null,
      ownersOptions: [],
      dispositionIdAnswered: null,
      dispositionIdNotAnswered: null,
      dispositionsOptions: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
    })
  },
  methods: {
    loadIntegration () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations?filter[where][gateway]=hubspot`)
          .then(integrations => {
            this.integration = integrations.pop()
            if (this.integration && this.integration.metadata) {
              if (this.integration.metadata.ownerId) this.ownerId = this.integration.metadata.ownerId
              if (this.integration.metadata.dispositionIdAnswered) this.dispositionIdAnswered = this.integration.metadata.dispositionIdAnswered
              if (this.integration.metadata.dispositionIdNotAnswered) this.dispositionIdNotAnswered = this.integration.metadata.dispositionIdNotAnswered
            }
            return resolve()
          })
          .catch(err => { this.$emit('onError', err) })
      })
    },
    saveIntegration () {
      return new Promise(resolve => {
        this.error = null
        if (!this.configReady) {
          this.error = 'Houve um erro ao salvar a integração. Por favor, tente novamente.'
          return resolve()
        }

        const integrationParams = {
          gateway: 'hubspot',
          webhook: true,
          webhookConstraint: {
            metadata: {
              api4comGateway: 'hubspot'
            }
          },
          metadata: {
            webhookUrl: process.env.API4COM_WEBHOOK_RECEIVER_URL,
            webhookVersion: 'v1.4',
            webhookTypes: ['channel-hangup']
          }
        }
        if (this.integration) integrationParams.id = this.integration.id
        if (this.integration && this.integration.metadata) integrationParams.metadata = Object.assign(this.integration.metadata, integrationParams.metadata)

        if (this.ownerId) integrationParams.metadata.ownerId = this.ownerId
        else delete integrationParams.metadata.ownerId

        if (this.dispositionIdAnswered) integrationParams.metadata.dispositionIdAnswered = this.dispositionIdAnswered
        else delete integrationParams.metadata.dispositionIdAnswered

        if (this.dispositionIdNotAnswered) integrationParams.metadata.dispositionIdNotAnswered = this.dispositionIdNotAnswered
        else delete integrationParams.metadata.dispositionIdNotAnswered

        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
            return resolve()
          })
          .catch(err => {
            this.error = err
          })
      })
    },
    toogleIntegration (event) {
      if (event.value === true) {
        return this.requestAuthorization()
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      this.error = null
      this.configReady = false
      this.loadOwners().then(_ => {
        this.loadDispositions().then(_ => {
          this.configReady = true
        })
      })
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.configReady = false
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    requestAuthorization () {
      return loopback
        .get(`/integrations/hubspot/authorize-link`)
        .then(link => {
          window.open(link, '_self')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    loadOwners () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations/hubspot/owners`)
          .then(owners => {
            if (owners && owners.length > 0) {
              this.ownersOptions = []
              if (!this.ownerId) this.ownerId = owners[0].id
              owners.forEach(owner => {
                this.ownersOptions.push({
                  value: owner.id,
                  text: `${owner.firstName} ${owner.lastName} (${owner.email})`
                })
              })
              return resolve()
            } else {
              return resolve()
            }
          })
          .catch(err => this.errorHandle(err))
      })
    },
    loadDispositions () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations/hubspot/dispositions`)
          .then(dispositions => {
            if (dispositions && dispositions.length > 0) {
              this.dispositionsOptions = []
              if (!this.dispositionIdAnswered) this.dispositionIdAnswered = dispositions[0].id
              if (!this.dispositionIdNotAnswered) this.dispositionIdNotAnswered = dispositions[0].id
              dispositions.filter(d => d.deleted === false).forEach(disposition => {
                this.dispositionsOptions.push({
                  value: disposition.id,
                  text: disposition.label
                })
              })
              return resolve()
            } else {
              return resolve()
            }
          })
          .catch(err => this.errorHandle(err))
      })
    },
    errorHandle (err) {
      console.error(err)
      this.error = {
        message: 'Houve um problema com a autenticação da integração. Talvez seja necessário reinstalar essa integração.'
      }
    },
    openTutorial () {
      this.$refs.tutorialHubSpot.open()
    }
  },
  computed: {
    // TEL-2243: esta tela guarda `error` como string escrita por ela mesma. O
    // ErrorAlert so aceita objeto — sem este envelope a validacao de prop reprova
    // e a tela nao renderiza erro nenhum. Mesmo padrao das telas de CRM irmas.
    errorAlert () {
      if (!this.error) return null
      return typeof this.error === 'string' ? { lines: [this.error] } : this.error
    },
    activeIntegration () {
      return this.integration && this.integration.gateway === 'hubspot'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/HubSpot.vue